var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.34 1.6L1.6 14.34m0-12.72l12.73 12.72","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Chevron.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = Chevron;

Chevron.default = Chevron;
